import { CommonResponse } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository,Connection,Like, LessThanOrEqual, MoreThanOrEqual, getManager } from "typeorm";

// import { RmCountPriceList } from "./rm-count-pricelist-entity";
import { RmCountPriceListAdapter } from "./dto/rm-count-pricelist.adapter";
import { DateFilter, ErrorResponse, HarvestTypes } from "@gtpl/shared-models/common-models";
import { RmCountPriceListDTO } from "./dto/rm-count-pricelist.dto";
import { RmCountPriceListRequest } from "./dto/rm-count-pricelist.request";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { RmCountPriceListLogsEntity } from "./rm-count-pricelist-logs.entity";
import { RmRates } from "./rm-rates-entity";
import {RmCountRanges} from 'apps/services/raw-material-procurement/src/app/raw-material-grn/rm-count-pricelist-entity'
import { AllRmCountPriceListResponse, CompanyCategoryEnum, RmCountPriceListColumns, RmCountPriceListRequestDto, RmCountPriceListResponseModel, RmRatesInfoReq, ProductCountDto } from "@gtpl/shared-models/raw-material-procurement";
import moment from "moment";
import appSettings from "apps/services/config";
import { IdRequest } from "@gtpl/shared-models/gtpl";
import { IndentIdRequest } from "../indent/dto/indent-id.request";
import { ProductCountEntity } from "./product-count-entity";
import { SkuPrice } from "./sku-price-entity";
import { SkuPriceLogs } from "./sku-price-logs-entity";
import {
    SkuPriceByDateRequestDto,
    SkuPriceCreateRequestDto,
    SkuPriceHistoryRequestDto,
} from "@gtpl/shared-models/raw-material-procurement";
@Injectable()

export class RmCountPriceListService{
    constructor(
        @InjectRepository(RmRates) 
        private rmCountPriceListRepository: Repository<RmRates>,
        
        @InjectRepository(ProductCountEntity)
        private productCountRepository: Repository<ProductCountEntity>,

        @InjectRepository(SkuPrice)
        private skuPriceRepository: Repository<SkuPrice>,

        @InjectRepository(SkuPriceLogs)
        private skuPriceLogsRepository: Repository<SkuPriceLogs>,
     
        // @InjectRepository(RmCountRanges)
        // private rmCountRepo: Repository<RmCountRanges>,

        private RmCountPriceListAdapter: RmCountPriceListAdapter,
      ) { }
   
    async createRmCountPriceList(dto:RmCountPriceListDTO,isUpdate: boolean,request:Request):Promise<RmCountPriceListResponseModel>{
        try{

            if(!isUpdate){
                const rmCountPriceList  = await this.getRmCountPriceList(dto.count,dto.category,dto.type);
                if (rmCountPriceList) {
                    throw new ErrorResponse(11104, 'Rm Count PriceList already exists');
                  }
            }else{
                const rmcountPriceListEntity = await this.getRmCountPriceList(dto.count,dto.category,dto.type);
                if (rmcountPriceListEntity) {
                    if(rmcountPriceListEntity.rmratesId!=dto.rmratesId){
                        throw new ErrorResponse(11104, 'Rm count Price List  already exists');
                    }
                }
            }
            const convertedrmCountPriceListEntity:RmRates = this.RmCountPriceListAdapter.convertDtoToEntity(dto,isUpdate);
            const savedrmCountPriceListEntity: RmRates = await this.rmCountPriceListRepository.save(convertedrmCountPriceListEntity);
            const savedrmCountPriceListDTO: RmCountPriceListDTO = this.RmCountPriceListAdapter.convertEntityToDto(savedrmCountPriceListEntity);

            if (savedrmCountPriceListDTO) {
                const response = new RmCountPriceListResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Rm Count PriceList date Updated Successfully':'Rm Count PriceList Created Successfully',[savedrmCountPriceListDTO]);
                return response;
              } else {
                throw new ErrorResponse(11106,'Rm PriceList saved but issue while transforming into DTO');
              }
        }
        catch(err){
            throw err
        }
    }
    async getRmCountPriceList(count: number,category:CompanyCategoryEnum,type:HarvestTypes): Promise<RmRates> {
        
        const response = await this.rmCountPriceListRepository.findOne({
        where: {count: count,category:category,type:type},
        });
        // console.log(response);
        if (response) {
        return response;
        } else {
        return null;
        }
    }
    async getAllRmCountPriceList(): Promise<AllRmCountPriceListResponse> {  
        try {
            const rmcountPriceListDTO: RmCountPriceListDTO[] = [];
           
            const rmCountPriceListEntities: RmRates[] = await this.rmCountPriceListRepository.find({
                order: { count:'ASC' },
            });
            
            if (rmCountPriceListEntities.length>0) {
                rmCountPriceListEntities.forEach(RmCountPriceListEntity => {
                const convertedrmPriceListDTO:RmCountPriceListDTO = this.RmCountPriceListAdapter.convertEntityToDto(RmCountPriceListEntity);
                rmcountPriceListDTO.push(convertedrmPriceListDTO);
                });
                const response = new AllRmCountPriceListResponse(true, 11208, "Rm Count PriceList retrieved successfully", rmcountPriceListDTO);
                return response;
            } else {
                //   console.log('yest')
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    // async activateOrDeactivateRmCountPriceList(rmCountPriceListReq: RmCountPriceListRequest): Promise<RmCountPriceListResponseModel> {
    //     try {
    //         const rmPriceListExists = await this.getRmCountPriceListById(rmCountPriceListReq.rmcountPriceListId);
    //         if (rmPriceListExists) {
    //             if (rmCountPriceListReq.versionFlag !== rmPriceListExists.versionFlag) {
    //                 throw new ErrorResponse(10113, 'Someone updated the current RmCountPriceList information.Refresh and try again');
    //             } else {
                    
    //             const rmPriceListStatus =  await this.rmCountPriceListRepository.update(
    //                 { rmcountPriceListId: rmCountPriceListReq.rmcountPriceListId },
    //                 { isActive: rmCountPriceListReq.isActive,updatedUser: rmCountPriceListReq.updatedUser });
                
    //             if (rmPriceListExists.isActive) {
    //                 if (rmPriceListStatus.affected) {
    //                     const rmPriceListResponse: RmCountPriceListResponseModel = new RmCountPriceListResponseModel(true, 10115, 'Rm Count PriceList is de-activated successfully');
    //                     return rmPriceListResponse;
    //                 } else {
    //                     throw new ErrorResponse(10111, 'Rm Count PriceList is already deactivated');
    //                 }
    //             } else {
    //                 if (rmPriceListStatus.affected) {
    //                     const rmPriceListResponse: RmCountPriceListResponseModel = new RmCountPriceListResponseModel(true, 10114, 'Rm CountPriceList is activated successfully');
    //                     return rmPriceListResponse;
    //                 } else {
    //                     throw new ErrorResponse(10112, 'Rm Count PriceList is already  activated');
    //                 }
    //             }
    //                 // }
    //             }
    //         } else {
    //             throw new ErrorResponse(99998, 'No Records Found');
    //         }
    //     } catch (err) {
    //         return err;
    //     }
    // }

    // async getRmCountPriceListById(rmCountPriceListId: number): Promise<RmCountPriceList> {
    //     //  console.log(employeeId);
    //         const response = await this.rmCountPriceListRepository.findOne({
    //         where: {rmCountPriceListId: rmCountPriceListId},
    //         });
            
    //         if (response) {
    //         return response;
    //         } else {
    //         return null;
    //         }
    //     }

        
  

    async getRmCountPriceListInfo(): Promise<RmCountPriceListResponseModel> {
        try {
            const info = await this.rmCountPriceListRepository.find()
            if (info) {
                return new RmCountPriceListResponseModel(true, 1, 'Data retrieved', info)
            } else {
                return new RmCountPriceListResponseModel(false, 0, 'No data found')
            }
        } catch (err) {
            return new RmCountPriceListResponseModel(false, 0, 'Something went wrong', err)
        }
    }

    async getRmCountPriceListInfoCount(req: any): Promise<RmCountPriceListResponseModel> {
        try {
            const countWithoutSpaces = req.country.replace(/\s/g, '%'); // Replace spaces with %
            const info = await this.rmCountPriceListRepository.findOne({
                where: {
                    count: Like(`%${countWithoutSpaces}%`) // Search for the modified country string
                }
            });
            if (info) {
                return new RmCountPriceListResponseModel(true, 1, 'Data retrieved', [info]);
            } else {
                return new RmCountPriceListResponseModel(false, 0, 'No data found');
            }
        } catch (err) {
            return new RmCountPriceListResponseModel(false, 0, 'Something went wrong', err);
        }
    }

    // async saveRmCountPricelistInfo(formData: any): Promise<RmCountPriceListResponseModel> {
    //     const transactionManager = new GenericTransactionManager();
    //     try {
    //         await transactionManager.startTransaction();
    //         const flag = new Set<boolean>();
    //         const columnArray = [];
    //         const updatedArray = formData.data.map((obj) => {
    //             const updatedObj = {};
    //             for (const key in obj) {
    //                 const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
    //                 if (newKey != '') {
    //                     columnArray.push(newKey);
    //                     updatedObj[newKey] = obj[key];
    //                 }
    //             }
    //             return updatedObj;
    //         });
    //         // console.log(updatedArray,"00000000000000");
            
    //         const difference = columnArray.filter((element) => !RmCountPriceListColumns.includes(element));
    //         // console.log(difference, "difference");
    
    //         if (difference.length > 0) {
    //             await transactionManager.releaseTransaction();
    //             return new RmCountPriceListResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
    //         }
    
    //         const convertedData = updatedArray.map((obj) => {
    //             const updatedObj = {};
    //             for (const key in obj) {
    //                 const value = obj[key];
    //                 updatedObj[key] = value === "" ? null : value;
    //             }
    //             return updatedObj;
    //         });
    
    //         for (const rec of convertedData) {
    //             try {
    //                 const existingData = await transactionManager.getRepository(RmRates).find({ where: { count: rec.Count,company:rec.Company,type:rec.Type} });
    
    //                 if (existingData.length > 0) {
    //                     // console.log(existingData, 'existingData');
    //                     const rmRateData = await transactionManager.getRepository(RmRates).update({ count: rec.Count,company:rec.Company,type:rec.Type }, { price: rec.Price,updatedUser:existingData[0].createdUser});
    //                     // console.log(rmRateData, 'rmrate data');
    //                     if (rmRateData.affected) {
    //                         flag.add(true);
    //                         const rmRateLog = new RmCountPriceListLogsEntity();
    //                         rmRateLog.effectiveFrom = existingData[0].updatedAt
    //                         rmRateLog.count = existingData[0].count;
    //                         rmRateLog.price = existingData[0].price;
    //                         rmRateLog.rmcountPriceListID = existingData[0]?.rmratesId;
    //                         rmRateLog.createdUser=existingData[0].createdUser
    //                         console.log(rmRateLog, '===============');
    //                         const saveLogData = await transactionManager.getRepository(RmCountPriceListLogsEntity).save(rmRateLog);
    //                         if (saveLogData) {
    //                             flag.add(true);
    //                         } else {
    //                             flag.add(false);
    //                             // Logging and continue processing
    //                             // console.error('Error occurred in log creation');
    //                             continue;
    //                         }
    //                     } else {
    //                         flag.add(false);
    //                         await transactionManager.releaseTransaction();
    //                         return new RmCountPriceListResponseModel(false, 0, 'Something went wrong in data updation');
    //                     }
    //                 } else {
    //                     const rmCountRange = await transactionManager.getRepository(RmCountRanges).find({
    //                         where: {
    //                             minValue: LessThanOrEqual(rec.Count),
    //                             maxValue: MoreThanOrEqual(rec.Count)
    //                         }
    //                     });
    
    //                     const Obj = new RmRates();
    //                     Obj.count = rec.Count;
    //                     Obj.price = rec.Price;
    //                     Obj.createdUser = formData.user
    //                     Obj.company = rec.Company
    //                     Obj.type = rec.Type
    //                     Obj.category = rec.Company === "BMR" ? CompanyCategoryEnum.OWN :CompanyCategoryEnum.OTHER
    //                     Obj.rmcountPriceListID = rmCountRange[0].rmcountPriceListId;
    //                     const saveData = await transactionManager.getRepository(RmRates).save(Obj);
    //                     if (saveData) {
    //                         flag.add(true);
    //                     } else {
    //                         flag.add(false);
    //                         await transactionManager.releaseTransaction();
    //                         return new RmCountPriceListResponseModel(false, 0, 'Something went wrong in data creation');
    //                     }
    //                 }
    
    //                 flag.add(true);
    //             } catch (error) {
    //                 console.error('Error occurred:', error);
    //                 flag.add(false);
    //             }
    //         }
    
    //         if (!flag.has(false)) {
    //             await transactionManager.completeTransaction();
    //             return new RmCountPriceListResponseModel(true, 1, 'Data saved successfully');
    //         } else {
    //             await transactionManager.releaseTransaction();
    //             return new RmCountPriceListResponseModel(false, 0, 'Something went wrong');
    //         }
    //     } catch (err) {
    //         // console.error('Error occurred:', err);
    //         await transactionManager.releaseTransaction();
    //         return new RmCountPriceListResponseModel(false, 0, 'Something went wrong');
    //     }
    // }

    // async saveRmCountPricelistInfo(formData: RmCountPriceListRequestDto): Promise<RmCountPriceListResponseModel> {
    //     const transactionManager = new GenericTransactionManager();
    //     try {
    //       await transactionManager.startTransaction();
      
    //       const flag = new Set<boolean>();
    //       const columnArray: string[] = [];
    //       const expectedColumns = ["sno", "count", "price", "company", "type"];
      
    //       const updatedArray = formData.data.map((obj, index) => {
    //         console.log(`Raw object at index ${index}:`, obj);
    //         const updatedObj: any = {};
    //         for (const key in obj) {
    //           const newKey = key.replace(/\s/g, "").replace(/[\(\)\.]/g, "").replace(/-/g, "").toLowerCase();
    //           if (newKey !== "" && expectedColumns.includes(newKey)) {
    //             columnArray.push(newKey);
    //             updatedObj[newKey] = obj[key];
    //           }
    //         }
    //         if (!updatedObj.count || isNaN(updatedObj.count)) {
    //           console.error(`Invalid count at index ${index}:`, updatedObj.count);
    //           updatedObj.count = null;
    //         }
    //         if (!updatedObj.type) {
    //           console.error(`Invalid type at index ${index}:`, updatedObj.type);
    //           updatedObj.type = null;
    //         }
    //         updatedObj.effectiveFromDate = obj.effectiveFromDate ? new Date(obj.effectiveFromDate) : new Date();
    //         updatedObj.effectiveToDate = obj.effectiveToDate ? new Date(obj.effectiveToDate) : null;
    //         return updatedObj;
    //       });
      
    //       const difference = columnArray.filter(
    //         (element) => !expectedColumns.includes(element)
    //       );
      
    //       if (difference.length > 0) {
    //         await transactionManager.releaseTransaction();
    //         return new RmCountPriceListResponseModel(
    //           false,
    //           1110,
    //           "Excel columns don't match. Please attach the correct file.",
    //           []
    //         );
    //       }
      
    //       const invalidRecords: { count: number; type: string; maxEffectiveDate: Date }[] = [];
    //       for (const rec of updatedArray) {
    //         if (rec.count === null || rec.type === null) {
    //           invalidRecords.push({
    //             count: rec.count ?? 0,
    //             type: rec.type ?? "Unknown",
    //             maxEffectiveDate: new Date(), 
    //           });
    //           continue;
    //         }
      
    //         const req = new RmRatesInfoReq(undefined, rec.type, undefined, rec.count);
    //         console.log(req,'ssssssssss')
    //         try {
    //           const maxEffectiveDateResponse = await this.getMaxEffectiveDate(req);
    //           console.log(maxEffectiveDateResponse,'aaaaaaaaaaa')
    //           if (maxEffectiveDateResponse.status && maxEffectiveDateResponse.data.length > 0 && maxEffectiveDateResponse.data[0].maxEffectedDate) {
    //             const maxEffectiveDate = new Date(maxEffectiveDateResponse.data[0].maxEffectedDate);
    //             const effectiveDate = new Date(rec.effectiveDate);
    //             console.log(effectiveDate,'efectiveDate')
    //             if (maxEffectiveDate >= effectiveDate) {
    //               invalidRecords.push({
    //                 count: rec.count,
    //                 type: rec.type,
    //                 maxEffectiveDate,
    //               });
    //             }
    //           }
    //         } catch (err) {
    //           console.error(`Error fetching maxEffectiveDate for count: ${rec.count}, type: ${rec.type}`, err);
    //           invalidRecords.push({
    //             count: rec.count,
    //             type: rec.type,
    //             maxEffectiveDate: new Date(),
    //           });
    //         }
    //       }
      
    //       if (invalidRecords.length > 0) {
    //         await transactionManager.releaseTransaction();
    //         // const errorMessage = `Invalid effective date or data for some records. Details: ${invalidRecords
    //         //   .map((rec) => `Count: ${rec.count}, Type: ${rec.type}, Max Effective Date: ${moment(rec.maxEffectiveDate).format("YYYY-MM-DD HH:mm:ss")}`)
    //         //   .join("; ")}`;
    //         const errorMessage = `Invalid effective date or data for some records`;
    //         return new RmCountPriceListResponseModel(
    //           false,
    //           1111,
    //           errorMessage,
    //           { invalidRecords }
    //         );
    //       }
      
      
    //       const convertedData = updatedArray.map((obj: any) => {
    //         const updatedObj: any = {};
    //         for (const key in obj) {
    //           const value = obj[key];
    //           updatedObj[key] = value === "" ? null : value;
    //         }
    //         updatedObj.effectiveDate = obj.effectiveDate || new Date();
    //         console.log(updatedObj,'ddddddddddd')
    //         return updatedObj;
    //       });
    //       console.log(convertedData,'ttttttttttt')
          
    //       for (const rec of convertedData) {
    //         try {
    //           if (rec.count === null || rec.type === null) {
    //             console.error("Skipping record due to invalid count or type:", rec);
    //             flag.add(false);
    //             continue;
    //           }
      
    //           const existingData = await transactionManager
    //             .getRepository(RmRates)
    //             .find({ where: { count: rec.count, company: rec.company, type: rec.type } });
      
    //           if (existingData.length > 0) {
    //             const rmRateData = await transactionManager.getRepository(RmRates).update(
    //               { count: rec.count, company: rec.company, type: rec.type },
    //               {
    //                 price: rec.price,
    //                 updatedUser: formData.user || rec.updatedUser || "",
    //                 effectiveDate: rec.effectiveDate ? moment.utc(rec.effectiveDate).toDate() : new Date(),
    //                 updatedAt: new Date(),
    //               }
    //             );
      
    //             if (rmRateData.affected) {
    //               flag.add(true);
    //               const rmRateLog = new RmCountPriceListLogsEntity();
    //               rmRateLog.effectiveFrom = rec.effectiveDate ? moment.utc(rec.effectiveDate).toDate() : new Date();
    //               rmRateLog.count = existingData[0].count;
    //               rmRateLog.price = existingData[0].price;
    //               rmRateLog.rmcountPriceListID = existingData[0]?.rmratesId;
    //               rmRateLog.createdUser = existingData[0].createdUser || formData.user || "";
    //               const saveLogData = await transactionManager.getRepository(RmCountPriceListLogsEntity).save(rmRateLog);
    //               if (saveLogData) {
    //                 flag.add(true);
    //               } else {
    //                 console.log("Log save failed for count:", rec.count);
    //                 flag.add(false);
    //                 continue;
    //               }
    //             } else {
    //               console.log("Update failed for count:", rec.count);
    //               flag.add(false);
    //               await transactionManager.releaseTransaction();
    //               return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data updation", []);
    //             }
    //           } else {
    //             const rmCountRange = await transactionManager.getRepository(RmCountRanges).find({
    //               where: {
    //                 minValue: LessThanOrEqual(rec.count),
    //                 maxValue: MoreThanOrEqual(rec.count),
    //               },
    //             });
      
    //             const Obj = new RmRates();
    //             Obj.count = rec.count;
    //             Obj.price = rec.price;
    //             Obj.createdUser = formData.user || "";
    //             Obj.company = rec.company || "";
    //             Obj.type = rec.type;
    //             Obj.category = rec.company === "BMR" ? CompanyCategoryEnum.OWN : CompanyCategoryEnum.OTHER;
    //             Obj.rmcountPriceListID = rmCountRange[0]?.rmcountPriceListId || 0;
    //             Obj.effectiveDate = rec.effectiveDate ? moment.utc(rec.effectiveDate).toDate() : new Date();
    //             Obj.createdAt = new Date();
    //             Obj.updatedAt = new Date();
    //             Obj.isActive = true;
    //             Obj.versionFlag = 1;
    //             const saveData = await transactionManager.getRepository(RmRates).save(Obj);
    //             if (saveData) {
    //               flag.add(true);
    //             } else {
    //               console.log("Create failed for count:", rec.count);
    //               flag.add(false);
    //               await transactionManager.releaseTransaction();
    //               return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data creation", []);
    //             }
    //           }
      
    //           flag.add(true);
    //         } catch (error) {
    //           console.error("Error occurred for count:", rec.count, error);
    //           flag.add(false);
    //         }
    //       }
      
    //       if (!flag.has(false)) {
    //         await transactionManager.completeTransaction();
    //         return new RmCountPriceListResponseModel(true, 1, "Data saved successfully", []);
    //       } else {
    //         await transactionManager.releaseTransaction();
    //         return new RmCountPriceListResponseModel(false, 0, "Something went wrong during processing", []);
    //       }
    //     } catch (err) {
    //       console.error("Error occurred:", err);
    //       await transactionManager.releaseTransaction();
    //       return new RmCountPriceListResponseModel(false, 0, "Something went wrong", []);
    //     }
    //   }


      
//       async saveRmCountPricelistInfo(formData: RmCountPriceListRequestDto): Promise<RmCountPriceListResponseModel> {
//   const transactionManager = new GenericTransactionManager();
//   try {
//     await transactionManager.startTransaction();
//     const flag = new Set<boolean>();
//     const columnArray: string[] = [];
//     const expectedColumns = ["sno", "count", "price", "company", "type"];

//     // Normalize keys and validate columns
//     const updatedArray = formData.data.map((obj, index) => {
//       const updatedObj: any = {};
//       for (const key in obj) {
//         const newKey = key.replace(/\s/g, "").replace(/[\(\)\.]/g, "").replace(/-/g, "").toLowerCase();
//         if (newKey && expectedColumns.includes(newKey)) {
//           columnArray.push(newKey);
//           updatedObj[newKey] = obj[key];
//         }
//       }
//       // Validate count and type
//       if (!updatedObj.count || isNaN(updatedObj.count)) {
//         console.error(`Invalid count at index ${index}:`, updatedObj.count);
//         updatedObj.count = null;
//       }
//       if (!updatedObj.type) {
//         console.error(`Invalid type at index ${index}:`, updatedObj.type);
//         updatedObj.type = null;
//       }
//       // Handle effective dates
//       updatedObj.effectiveFromDate = obj.effectiveFromDate ? new Date(obj.effectiveFromDate) : new Date();
//       updatedObj.effectiveToDate = obj.effectiveToDate ? new Date(obj.effectiveToDate) : null;
//       return updatedObj;
//     });

//     // Check for invalid columns
//     const difference = columnArray.filter((element) => !expectedColumns.includes(element));
//     if (difference.length > 0) {
//       await transactionManager.releaseTransaction();
//       return new RmCountPriceListResponseModel(
//         false,
//         1110,
//         "Excel columns don't match. Please attach the correct file.",
//         []
//       );
//     }

//     // Validate effective dates
//     const invalidRecords: { count: number; type: string; maxEffectiveDate: Date }[] = [];
//     for (const rec of updatedArray) {
//       if (rec.count === null || rec.type === null) {
//         invalidRecords.push({
//           count: rec.count ?? 0,
//           type: rec.type ?? "Unknown",
//           maxEffectiveDate: new Date(),
//         });
//         continue;
//       }

//       const req = new RmRatesInfoReq(undefined, rec.type, undefined, rec.count);
//       try {
//         const maxEffectiveDateResponse = await this.getMaxEffectiveDate(req);
//         if (
//           maxEffectiveDateResponse.status &&
//           maxEffectiveDateResponse.data.length > 0 &&
//           maxEffectiveDateResponse.data[0].maxEffectedDate
//         ) {
//           const maxEffectiveDate = new Date(maxEffectiveDateResponse.data[0].maxEffectedDate);
//           const effectiveFromDate = new Date(rec.effectiveFromDate);
//           if (maxEffectiveDate >= effectiveFromDate) {
//             invalidRecords.push({
//               count: rec.count,
//               type: rec.type,
//               maxEffectiveDate,
//             });
//           }
//         }
//       } catch (err) {
//         console.error(`Error fetching maxEffectiveDate for count: ${rec.count}, type: ${rec.type}`, err);
//         invalidRecords.push({
//           count: rec.count,
//           type: rec.type,
//           maxEffectiveDate: new Date(),
//         });
//       }
//     }

//     if (invalidRecords.length > 0) {
//       await transactionManager.releaseTransaction();
//       return new RmCountPriceListResponseModel(
//         false,
//         1111,
//         `Invalid effective date or data for some records`,
//         { invalidRecords }
//       );
//     }

//     // Process records
//     const convertedData = updatedArray.map((obj) => {
//       const updatedObj: any = {};
//       for (const key in obj) {
//         updatedObj[key] = obj[key] === "" ? null : obj[key];
//       }
//       return updatedObj;
//     });

//     for (const rec of convertedData) {
//       try {
//         if (rec.count === null || rec.type === null) {
//           console.error("Skipping record due to invalid count or type:", rec);
//           flag.add(false);
//           continue;
//         }

//         const existingData = await transactionManager
//           .getRepository(RmRates)
//           .find({ where: { count: rec.count, company: rec.company, type: rec.type } });

//         if (existingData.length > 0) {
//           const rmRateData = await transactionManager.getRepository(RmRates).update(
//             { count: rec.count, company: rec.company, type: rec.type },
//             {
//               price: rec.price,
//               updatedUser: formData.user || existingData[0].createdUser || "",
//               effectiveFromDate: moment.utc(rec.effectiveFromDate).toDate(),
//               effectiveToDate: rec.effectiveToDate ? moment.utc(rec.effectiveToDate).toDate() : null,
//               updatedAt: new Date(),
//             }
//           );

//           if (rmRateData.affected) {
//             flag.add(true);
//             const rmRateLog = new RmCountPriceListLogsEntity();
//             rmRateLog.effectiveFrom = existingData[0].effectiveFromDate || moment.utc(rec.effectiveFromDate).toDate();
//             rmRateLog.effectiveToDate = rec.effectiveToDate
//               ? moment.utc(rec.effectiveToDate).toDate()
//               : moment.utc(rec.effectiveFromDate).subtract(1, "day").toDate();
//             rmRateLog.count = existingData[0].count;
//             rmRateLog.price = existingData[0].price;
//             rmRateLog.rmcountPriceListID = existingData[0]?.rmratesId;
//             rmRateLog.createdUser = existingData[0].createdUser || formData.user || "";
//             const saveLogData = await transactionManager.getRepository(RmCountPriceListLogsEntity).save(rmRateLog);
//             if (!saveLogData) {
//               console.log("Log save failed for count:", rec.count);
//               flag.add(false);
//             }
//           } else {
//             console.log("Update failed for count:", rec.count);
//             flag.add(false);
//             await transactionManager.releaseTransaction();
//             return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data updation", []);
//           }
//         } else {
//           const rmCountRange = await transactionManager.getRepository(RmCountRanges).find({
//             where: {
//               minValue: LessThanOrEqual(rec.count),
//               maxValue: MoreThanOrEqual(rec.count),
//             },
//           });

//           const obj = new RmRates();
//           obj.count = rec.count;
//           obj.price = rec.price;
//           obj.createdUser = formData.user || "";
//           obj.company = rec.company || "";
//           obj.type = rec.type;
//           obj.category = rec.company === "BMR" ? CompanyCategoryEnum.OWN : CompanyCategoryEnum.OTHER;
//           obj.rmcountPriceListID = rmCountRange[0]?.rmcountPriceListId || 0;
//           obj.effectiveFromDate = moment.utc(rec.effectiveFromDate).toDate();
//           obj.effectiveToDate = rec.effectiveToDate ? moment.utc(rec.effectiveToDate).toDate() : null;
//           obj.createdAt = new Date();
//           obj.updatedAt = new Date();
//           obj.isActive = true;
//           obj.versionFlag = 1;
//           const saveData = await transactionManager.getRepository(RmRates).save(obj);
//           if (saveData) {
//             flag.add(true);
//             const rmRateLog = new RmCountPriceListLogsEntity();
//             rmRateLog.effectiveFrom = moment.utc(rec.effectiveFromDate).toDate();
//             rmRateLog.effectiveToDate = rec.effectiveToDate
//               ? moment.utc(rec.effectiveToDate).toDate()
//               : moment.utc(rec.effectiveFromDate).subtract(1, "day").toDate();
//             rmRateLog.count = rec.count;
//             rmRateLog.price = rec.price;
//             rmRateLog.rmcountPriceListID = saveData?.rmratesId || 0;
//             rmRateLog.createdUser = formData.user || "";
//             const saveLogData = await transactionManager.getRepository(RmCountPriceListLogsEntity).save(rmRateLog);
//             if (!saveLogData) {
//               console.log("Log save failed for count:", rec.count);
//               flag.add(false);
//             }
//           } else {
//             console.log("Create failed for count:", rec.count);
//             flag.add(false);
//             await transactionManager.releaseTransaction();
//             return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data creation", []);
//           }
//         }

//         flag.add(true);
//       } catch (error) {
//         console.error("Error occurred for count:", rec.count, error);
//         flag.add(false);
//       }
//     }

//     if (!flag.has(false)) {
//       await transactionManager.completeTransaction();
//       return new RmCountPriceListResponseModel(true, 1, "Data saved successfully", []);
//     } else {
//       await transactionManager.releaseTransaction();
//       return new RmCountPriceListResponseModel(false, 0, "Something went wrong during processing", []);
//     }
//   } catch (err) {
//     console.error("Error occurred:", err);
//     await transactionManager.releaseTransaction();
//     return new RmCountPriceListResponseModel(false, 0, "Something went wrong", []);
//   }
// }

async saveRmCountPricelistInfo(formData: any): Promise<RmCountPriceListResponseModel> {
    const transactionManager = new GenericTransactionManager();
    try {
      await transactionManager.startTransaction();
      const flag = new Set<boolean>();
      const columnArray: string[] = [];
      const expectedColumns = ["count", "price", "company", "type"]; 

      const batchSize = 100;
      const batches = [];
      for (let i = 0; i < formData.data.length; i += batchSize) {
        batches.push(formData.data.slice(i, i + batchSize));
      }
      const promises = batches.map(async (batch) => {
        const updatedArray = batch.map((obj, index) => {
          const updatedObj: any = {};
          for (const key in obj) {
            const newKey = key.replace(/\s/g, "").replace(/[\(\)\.]/g, "").replace(/-/g, "").toLowerCase();
            updatedObj[newKey] = obj[key];
          }
  
          if (!updatedObj.count || isNaN(updatedObj.count)) {
            updatedObj.count = null;
          }
          if (!updatedObj.type) {
            updatedObj.type = null;
          }
          // Ensure effectiveFromDate is mandatory
          if (!obj.effectiveFromDate) {
            throw new Error("effectiveFromDate is mandatory");
          }
          updatedObj.effectiveFromDate = new Date(obj.effectiveFromDate);
          updatedObj.effectiveToDate = obj.effectiveToDate ? new Date(obj.effectiveToDate) : null;
          return updatedObj;
        });
        const difference = columnArray.filter(
          (element) => !expectedColumns.includes(element)
        );
        if (difference.length > 0) {
          return new RmCountPriceListResponseModel(
            false,
            1110,
            "Excel columns don't match. Please attach the correct file.",
            []
          );
        }

        const invalidRecords: { count: number; type: string; maxEffectiveDate: Date }[] = [];
        for (const rec of updatedArray) {
          if (rec.count === null || rec.type === null) {
            invalidRecords.push({
              count: rec.count ?? 0,
              type: rec.type ?? "Unknown",
              maxEffectiveDate: new Date(),
            });
            continue;
          }

          const req = new RmRatesInfoReq(undefined, rec.type, undefined, rec.count);
          try {
            const maxEffectiveDateResponse = await this.getMaxEffectiveDate(req);
            if (
              maxEffectiveDateResponse.status &&
              maxEffectiveDateResponse.data.length > 0 &&
              maxEffectiveDateResponse.data[0].maxEffectedDate
            ) {
              const maxEffectiveDate = new Date(maxEffectiveDateResponse.data[0].maxEffectedDate);
              const effectiveFromDate = new Date(rec.effectiveFromDate);
              if (maxEffectiveDate >= effectiveFromDate) {
                invalidRecords.push({
                  count: rec.count,
                  type: rec.type,
                  maxEffectiveDate,
                });
              }
            }
          } catch (err) {
            console.error(`Error fetching maxEffectiveDate for count: ${rec.count}, type: ${rec.type}`, err);
            invalidRecords.push({
              count: rec.count,
              type: rec.type,
              maxEffectiveDate: new Date(),
            });
          }
        }
  
        if (invalidRecords.length > 0) {
          return new RmCountPriceListResponseModel(
            false,
            1111,
            `Invalid effective date or data for some records`,
            { invalidRecords }
          );
        }
        const convertedData = updatedArray.map((obj: any) => {
          const updatedObj: any = {};
          for (const key in obj) {
            const value = obj[key];
            updatedObj[key] = value === "" ? null : value;
          }
          updatedObj.effectiveFromDate = obj.effectiveFromDate;
          updatedObj.effectiveToDate = obj.effectiveToDate;
          return updatedObj;
        });
  
        const updatePromises = convertedData.map(async (rec) => {
          try {
            if (rec.count === null || rec.type === null) {
              return;
            }
  
            const existingData = await transactionManager
              .getRepository(RmRates)
              .find({ where: { count: rec.count, company: rec.company, type: rec.type } });
  
            if (existingData.length > 0) {
              const rmRateData = await transactionManager.getRepository(RmRates).update(
                { count: rec.count, company: rec.company, type: rec.type },
                {
                  price: rec.price,
                  updatedUser: formData.user || existingData[0].createdUser || "",
                  effectiveFromDate: rec.effectiveFromDate,
                  effectiveToDate: rec.effectiveToDate ? moment(rec.effectiveToDate).toDate() : null,
                  updatedAt: new Date(),
                }
              );
  
              if (rmRateData.affected) {
                const rmRateLog = new RmCountPriceListLogsEntity();
                rmRateLog.effectiveFrom = existingData[0].effectiveFromDate;
                rmRateLog.effectiveToDate = existingData[0].effectiveToDate
                  ? existingData[0].effectiveToDate
                  : moment.utc(rec.effectiveFromDate).subtract(1, 'day').toDate();
                rmRateLog.count = existingData[0].count;
                rmRateLog.price = existingData[0].price;
                rmRateLog.rmcountPriceListID = existingData[0]?.rmratesId;
                rmRateLog.createdUser = existingData[0].createdUser || formData.user || "";
                const saveLogData = await transactionManager.getRepository(RmCountPriceListLogsEntity).save(rmRateLog);
                if (!saveLogData) {
                  flag.add(false);
                }
              } else {
                flag.add(false);
                return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data updation", []);
              }
            } else {
              const rmCountRange = await transactionManager.getRepository(RmCountRanges).find({
                where: {
                  minValue: LessThanOrEqual(rec.count),
                  maxValue: MoreThanOrEqual(rec.count),
                },
              });
  
              const obj = new RmRates();
              obj.count = rec.count;
              obj.price = rec.price;
              obj.createdUser = formData.user || "";
              obj.company = rec.company || "";
              obj.type = rec.type;
              obj.category = rec.company === "BMR" ? CompanyCategoryEnum.OWN : CompanyCategoryEnum.OTHER;
              obj.rmcountPriceListID = rmCountRange[0]?.rmcountPriceListId || 0;
              obj.effectiveFromDate = moment.utc(rec.effectiveFromDate).toDate();
              obj.effectiveToDate = rec.effectiveToDate ? moment.utc(rec.effectiveToDate).toDate() : null;
              obj.createdAt = new Date();
              obj.updatedAt = new Date();
              obj.isActive = true;
              obj.versionFlag = 1;
  
              const saveData = await transactionManager.getRepository(RmRates).save(obj);
              if (saveData) {
                const rmRateLog = new RmCountPriceListLogsEntity();
                rmRateLog.effectiveFrom = moment.utc(rec.effectiveFromDate).toDate();
                rmRateLog.effectiveToDate = existingData[0].effectiveToDate
                ? existingData[0].effectiveToDate
                  : moment.utc(rec.effectiveFromDate).subtract(1, 'day').toDate();
                rmRateLog.count = rec.count;
                rmRateLog.price = rec.price;
                rmRateLog.rmcountPriceListID = saveData?.rmratesId || 0;
                rmRateLog.createdUser = formData.user || "";
                const saveLogData = await transactionManager.getRepository(RmCountPriceListLogsEntity).save(rmRateLog);
                if (!saveLogData) {
                  flag.add(false);
                }
              } else {
                flag.add(false);
                return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data creation", []);
              }
            }
          } catch (error) {
            console.error("Error occurred for count:", rec.count, error);
            flag.add(false);
            return new RmCountPriceListResponseModel(false, 0, "Something went wrong in data processing", []);
          }
        });
        await Promise.all(updatePromises);
      });

      await Promise.all(promises);
  
      await transactionManager.completeTransaction();
  
      return new RmCountPriceListResponseModel(true, 1, "Data saved successfully", []);
    } catch (err) {
      console.error("Error occurred:", err);
      await transactionManager.releaseTransaction();
      return new RmCountPriceListResponseModel(false, 0, "Something went wrong", []);
    }
  }
  
    
    async  getRmRatesData(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            // let companies = await manager.query(`
            //     SELECT DISTINCT(company) FROM rm_rates
            //     WHERE company != '' AND company != 'Aqua Brama' AND category != "${CompanyCategoryEnum.OWN}" AND DATE(created_at) = (SELECT MAX(DATE(created_at)) FROM rm_rates))`);
            let query = `SELECT count,price,company FROM rm_rates
            WHERE company != '' AND company != 'Aqua Brama' AND category != "${CompanyCategoryEnum.OWN}" AND DATE(created_at) = (
    SELECT MAX(DATE(created_at)) 
    FROM rm_rates
)`;
    
            const results = await manager.query(query);
            console.log(results,'ppppppppp');
            
            interface PriceInfoModel {
                count: string;
                price: number;
                colorVar: boolean;
                company: string;
            }
            
            let priceInfo: PriceInfoModel[] = [];
            let prevCount: string;
            let prevPrice: number = 0;
            let countVal: string;
            let sameCounts: number[] = [];
            let colorVal: boolean;
            let prevCompany: string;
    
            if (results) {
                for (const priceRec of results) {
                    if (prevPrice === priceRec.price && priceRec.company === prevCompany) {
                        sameCounts.push(parseInt(prevCount));
                        countVal = Math.min(...sameCounts) + '-' + priceRec.count;
                        priceInfo.splice(-1);
                        colorVal = true;
                    } else {
                        sameCounts = [];
                        countVal = priceRec.count;
                        colorVal = false;
                    }
                    priceInfo.push({ count: countVal, price: priceRec.price, colorVar: colorVal, company: priceRec.company });
                    prevCount = priceRec.count;
                    prevPrice = priceRec.price;
                    prevCompany = priceRec.company;
                }

                
                if(priceInfo.length >0 ){
                const resultMap = new Map<string, { count: string; price: number }[]>();
                for (const result of priceInfo) {
                    const { count, price, company } = result;
                    if (!resultMap.has(company)) {
                        resultMap.set(company, []);
                    }
                    resultMap.get(company).push({ count, price });
                }
        
                const responseData = [];
                for (const [company, data] of resultMap.entries()) {
                    responseData.push({ company, data });
                }

                if (responseData.length > 0) {
                    return new CommonResponse(true, 1, 'Data retrieved successfully', responseData);
                } else {
                    return new CommonResponse(false, 0, 'No data found', []);
                }
            }
            else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
            }
    
        } catch (err) {
            throw (err);
        }
    }
    async getCompanies():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT DISTINCT(company) FROM rm_rates
            WHERE company != '' AND company != 'Aqua Brama' AND category != "${CompanyCategoryEnum.OWN}" AND DATE(created_at) = (SELECT MAX(DATE(created_at)) FROM rm_rates)`
            
            
            const result = await manager.query(query)
           
         
            if(result.length > 0){
              
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getRmRatesBmr():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT r.count,r.price FROM rm_rates r
            WHERE category = "${CompanyCategoryEnum.OWN}" AND DATE(created_at) = (SELECT MAX(DATE(created_at)) FROM rm_rates)`
            query +=` Group by r.count`
            
            const result = await manager.query(query)
            interface PriceInfoModel {
                count: string;
                price: number;
                colorVar: boolean;
                company: string;
            }
            
            let priceInfo: PriceInfoModel[] = [];
            let prevCount: string;
            let prevPrice: number = 0;
            let countVal: string;
            let sameCounts: number[] = [];
            let colorVal: boolean;
            let prevCompany: string;
    
            if(result.length > 0){
                for (const priceRec of result) {
                    if (prevPrice === priceRec.price && priceRec.company === prevCompany) {
                        sameCounts.push(parseInt(prevCount));
                        countVal = Math.min(...sameCounts) + '-' + priceRec.count;
                        priceInfo.splice(-1);
                        colorVal = true;
                    } else {
                        sameCounts = [];
                        countVal = priceRec.count;
                        colorVal = false;
                    }
                    priceInfo.push({ count: countVal, price: priceRec.price, colorVar: colorVal, company: priceRec.company });
                    prevCount = priceRec.count;
                    prevPrice = priceRec.price;
                    prevCompany = priceRec.company;
                }
                return new CommonResponse(true, 1,'Data retrieved successfully', priceInfo)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getRmRatesAqua():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT r.count,r.price FROM rm_rates r
            WHERE company = 'Aqua Brama' AND DATE(created_at) = (SELECT MAX(DATE(created_at)) FROM rm_rates)`
            
            
            const result = await manager.query(query)
            interface PriceInfoModel {
                count: string;
                price: number;
                colorVar: boolean;
                company: string;
            }
            
            let priceInfo: PriceInfoModel[] = [];
            let prevCount: string;
            let prevPrice: number = 0;
            let countVal: string;
            let sameCounts: number[] = [];
            let colorVal: boolean;
            let prevCompany: string;
    
            if(result.length > 0){
                for (const priceRec of result) {
                    if (prevPrice === priceRec.price && priceRec.company === prevCompany) {
                        sameCounts.push(parseInt(prevCount));
                        countVal = Math.min(...sameCounts) + '-' + priceRec.count;
                        priceInfo.splice(-1);
                        colorVal = true;
                    } else {
                        sameCounts = [];
                        countVal = priceRec.count;
                        colorVal = false;
                    }
                    priceInfo.push({ count: countVal, price: priceRec.price, colorVar: colorVal, company: priceRec.company });
                    prevCount = priceRec.count;
                    prevPrice = priceRec.price;
                    prevCompany = priceRec.company;
                }
                return new CommonResponse(true, 1,'Data retrieved successfully', priceInfo)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    
    async  getRmPriceDeviation(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let dateQuery = `SELECT r.count, r.price,created_at as latestDate FROM rm_rates r
            WHERE  category = "${CompanyCategoryEnum.OWN}" AND DATE(created_at) = (SELECT MAX(DATE(created_at)) FROM rm_rates)`;
            const date = await manager.query(dateQuery);
    
            if (date.length > 0) {
                const latestDate = new Date(date?.[0]?.latestDate);
                const nextDate = new Date(latestDate);
                nextDate.setDate(nextDate.getDate() + 7);
                const formattedNextDate = nextDate.toISOString().split('T')[0];
    
                let query = `SELECT g.grn_date, gi.count, gi.price,gi.grn_item_id,gi.farmer ,f.name FROM grn_items gi
                LEFT JOIN grn g ON g.grn_id = gi.grn_id
                LEFT JOIN erpx_dev_masters.suppliers f ON f.supplier_id = gi.farmer
                WHERE g.grn_date BETWEEN '${moment(date?.[0]?.latestDate).format('YYYY-MM-DD')}' AND '${formattedNextDate}'`;
                const result = await manager.query(query);
                if (result.length > 0) {
                    let response = [];
                    for (const res of result) {
                        const countRange = date.filter((e)=>e.count === res.count)
                        
                        if (countRange.length >0) {
                            let diff = Number(res.price) - Number(countRange?.[0]?.price?countRange?.[0]?.price:0);
                            if(diff !== 0 || undefined){
                                
                            response.push({
                                deviation: diff,
                                count: res.count,
                                farmer: res.name,
                                date: res.grn_date,
                                price: res.price
                            });
                        }
                        }
                    }
    
                    return new CommonResponse(true, 1, 'data retrieved', response);
                }
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
    
    // async getRmPriceDeviation ():Promise<CommonResponse>{
    //     try{
    //         const manager = getManager()
    //         let dateQuery =`SELECT MAX(created_at) as latestDate FROM rm_rates`
    //         const date =await manager.query(dateQuery)
    //         console.log(date[0].latestDate,'dateeeee');
            
    //         if(date.length > 0){
    //             const latestDate = new Date(date[0].latestDate);
    //             const nextDate = new Date(latestDate);
    //             nextDate.setDate(nextDate.getDate() + 7);
    //             const formattedNextDate = nextDate.toISOString().split('T')[0];
    
    //             let query = `SELECT g.grn_date,gi.count,gi.price,f.name FROM grn_items gi
    //             LEFT JOIN grn g ON g.grn_id = gi.grn_id
    //             LEFT JOIN erpx_dev_masters.suppliers f ON f.supplier_id
    //             WHERE g.grn_date BETWEEN '${latestDate}' AND '${formattedNextDate}'`
    //             const result = await manager.query(query)
    //             if(result.length > 0){
    //                 console.log(result,'7777777tttttttt');

    //                 let response =[]
    //                 const countRanges = await manager.query(`SELECT r.count,r.price FROM rm_rates r
    //                 WHERE  category = "${CompanyCategoryEnum.OWN}" AND DATE(created_at) = '${moment(latestDate).format('YYYY-MM-DD')}'`)
    //                 for(const res of result ){
    //                     // console.log(res,'uuuuuuuuuuuuu');

    //                     for(const val of countRanges){
    //                         if(val.count === res.count){
    //                             console.log(val,'sameeeeeeeeeee');
                                
    //                         let diff = Number(val.count) - Number(res.count)
    //                         response.push({
    //                             deviation:diff,
    //                             count:res.count,
    //                             farmer:res.name,
    //                             date:res.grn_date,
    //                             price:res.price})
    //                         }
    //                     }
                                            
    //                      // const countValue = res.count;
    //                     // let exist = false;
    //                     // for (const range of countRanges) {
    //                     //     const [start, end] = range.count.split('-').map(Number);
    //                     //         if (countValue >= start && countValue <= end) {
    //                     //             exist = true;
    //                     //             break;
    //                     //         }
    //                     //     }
    //                 }

    //                 return new CommonResponse(true, 1,'data retrived',response)
    //             }
           
    //     }else{
                
    //         return new CommonResponse(false, 0,'No data found',[])
    //     }
    //     }catch(err){
    //         throw(err)
    //     }
    // }

    async getRmReportDates ():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let dateQuery =`SELECT MAX(created_at) as latestDate FROM rm_rates`
            const date =await manager.query(dateQuery)
            
            if(date.length > 0){
                let response =[]
                const latestDate = new Date(date[0].latestDate);
                const nextDate = new Date(latestDate);
                nextDate.setDate(nextDate.getDate() + 1);
                const formattedNextDate = nextDate.toISOString().split('T')[0];
                response.push({latest:latestDate,harvestDate:formattedNextDate})
             return new CommonResponse(true, 1,'data retrived successfully',response)
        }else{
                
            return new CommonResponse(false, 0,'No data found in that dates',[])
        }
        }catch(err){
            throw(err)
        }
    }

    async getRmRatesAgainstUploadedDate(req:RmRatesInfoReq):Promise<CommonResponse>{
        const manager = getManager()
        try{
            let count
        if(req.count != undefined){
            const getReferenceCountQry = `SELECT reference_count as count from ${appSettings.rm_procure_db} .half_count_ranges WHERE min_count <= ${req.count} AND max_count >= ${req.count}`
            const getRefCount = await manager.query(getReferenceCountQry)
            if(getRefCount.length > 0){
                count = getRefCount[0].count
            }else{
                count = req.count
            }
            
        }
        let indentDate
        if(req.indentId > 0){
            const getIndentDateQry = `SELECT DATE(indent_date) as indentDate from ${appSettings.rm_procure_db} .indent WHERE indent_id = ${req.indentId}`
            const indentDateInfo = await manager.query(getIndentDateQry)
            indentDate = indentDateInfo[0].indentDate
        }
        if(req.indentDate != undefined){
            indentDate = req.indentDate
        }

        let rmRatesLogQry = `SELECT rl.count,rl.price,r.company,r.category,r.type FROM ${appSettings.rm_procure_db} .rm_rates_logs rl
        LEFT JOIN rm_rates r ON r.rm_rates_id = rl.rm_rates_id
        WHERE '${moment(indentDate).format('YYYY-MM-DD')}' BETWEEN DATE(rl.effective_from) AND DATE(rl.effective_to_date) `
        if(req.harvestType != undefined){
            rmRatesLogQry += ` AND r.type = '${req.harvestType}'`
        }
        if(req.category != undefined){
            rmRatesLogQry += ` AND r.category = '${req.category}'`
        }
        if(req.count != undefined){
            rmRatesLogQry += ` AND rl.count = ${count}`
        }
        let rmRatesLogConditionQry = `SELECT rl.count FROM ${appSettings.rm_procure_db} .rm_rates_logs rl
        LEFT JOIN rm_rates r ON r.rm_rates_id = rl.rm_rates_id
        WHERE '${moment(indentDate).format('YYYY-MM-DD')}' BETWEEN DATE(rl.effective_from) AND DATE(rl.effective_to_date) `
        if(req.harvestType != undefined){
            rmRatesLogConditionQry += ` AND r.type = '${req.harvestType}'`
        }
        if(req.category != undefined){
            rmRatesLogConditionQry += ` AND r.category = '${req.category}'`
        }
        if(req.count != undefined){
            rmRatesLogConditionQry += ` AND rl.count = ${count}`
        }
        let getRmRateQry = ` ${rmRatesLogQry}
        UNION ALL
        SELECT rr.count,rr.price,rr.company,rr.category,rr.type FROM rm_rates rr WHERE rr.count NOT IN (${rmRatesLogConditionQry})
        `
        if(req.harvestType != undefined){
            getRmRateQry += ` AND rr.type = '${req.harvestType}'`
        }
        if(req.category != undefined){
            getRmRateQry += ` AND rr.category = '${req.category}'`
        }
        if(req.count != undefined){
            getRmRateQry += ` AND rr.count = ${count}`
        }
       
            
        const getRmRatesInfo = await manager.query(getRmRateQry)
        if(getRmRatesInfo.length > 0){
            return new CommonResponse(true,1,'Data retrieved',getRmRatesInfo)
        }else{
            return new CommonResponse(false,0,'No data found')
        }
        }catch(err){
            throw err
        }
    }

    async getHalfCountRangesInfo():Promise<CommonResponse>{
        const manager = getManager()
        try{
            const getInfoQry = `Select * from ${appSettings.rm_procure_db} .half_count_ranges`
            const getInfo = await manager.query(getInfoQry)
            if(getInfoQry.length > 0){
                return new CommonResponse(true,1,'Data retrieved',getInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getMaxEffectiveDate(req: RmRatesInfoReq): Promise<CommonResponse> {
        try {
            if (!req.count || !req.harvestType) {
                return new CommonResponse(false, 0, "Invalid count or type", [{ maxEffectedDate: null }]);
            }
    
            const manager = getManager();
            const query = `
                SELECT MAX(rrl.effective_from) AS maxEffectedDate
                FROM ${appSettings.rm_procure_db}.rm_rates rr
                LEFT JOIN ${appSettings.rm_procure_db}.rm_rates_logs rrl ON rrl.rm_rates_id = rr.rm_rates_id
                WHERE rr.count = ? AND rr.type = ?;
            `;
            const result = await manager.query(query, [req.count, req.harvestType]);
    
            if (result.length > 0 && result[0].maxEffectedDate) {
                return new CommonResponse(true, 1, "Data retrieved successfully", result);
            } else {
                return new CommonResponse(true, 0, "No max effective date found", [{ maxEffectedDate: null }]);
            }
        } catch (err) {
            console.error("Error in getMaxEffectiveDate:", err);
            throw err;
        }
    }

    async createProductCount(req: ProductCountDto): Promise<CommonResponse> {
    try {

        const normalizeCount = (value: string): string => {
            const trimmed = value?.toString().trim();

            if (!isNaN(Number(trimmed))) {
                return Number(trimmed).toString();
            }

            return trimmed;
        };

        const newCount = normalizeCount(req.productCount);

        const existingCounts = await this.productCountRepository.find({
            select: ['id', 'count'],
        });

        const duplicate = existingCounts.find(
            (x) => normalizeCount(x.count) === newCount
        );

        if (duplicate) {
            return new CommonResponse(
                false,
                0,
                `Count ${req.productCount} already exists`,
                null
            );
        }

        const newEntity = new ProductCountEntity();

        newEntity.count = req.productCount;
        newEntity.createdUser = req.createdUser;
        newEntity.updatedUser = req.createdUser;

        const res = await this.productCountRepository.save(newEntity);

        return new CommonResponse(
            true,
            1,
            'Product Count created successfully',
            res
        );
    } catch (err) {
        console.error(err);
        throw err;
    }
}

    async updateProductCount(req: ProductCountDto): Promise<CommonResponse> {
    try {

        const normalizeCount = (value: string): string => {
            const trimmed = value?.toString().trim();

            if (!isNaN(Number(trimmed))) {
                return Number(trimmed).toString();
            }

            return trimmed;
        };

        const newCount = normalizeCount(req.productCount);

        const existingCounts = await this.productCountRepository.find({
            select: ['id', 'count'],
        });

        const duplicate = existingCounts.find(
            (x) =>
                x.id !== req.productCountId &&
                normalizeCount(x.count) === newCount
        );

        if (duplicate) {
            return new CommonResponse(
                false,
                0,
                `Count ${req.productCount} already exists`,
                null
            );
        }

        const entity = await this.productCountRepository.findOne({
            where: {
                productCountId: req.productCountId,
            },
        });

        if (!entity) {
            return new CommonResponse(
                false,
                0,
                'Product Count not found',
                null
            );
        }

        entity.count = req.productCount;
        entity.updatedUser = req.updatedUser;

        const res = await this.productCountRepository.save(entity);

        return new CommonResponse(
            true,
            1,
            'Product Count updated successfully',
            res
        );
    } catch (err) {
        console.error(err);
        throw err;
    }
}

    async getAllProductCount(req?: any): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT 
                pc.*,
                sku.short_code AS productName
            FROM product_count pc
            LEFT JOIN ${appSettings.masters_db}.sku_codes sku 
                ON sku.sku_code_id = pc.product_id
            WHERE 1=1
            `
            if (req.productId) {
                query += ` AND pc.product_id = ${req.productId}`
            }
            query+=` ORDER BY pc.id DESC`
            const list = await manager.query(query);


            if (list.length > 0) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', list);
            } else {
            return new CommonResponse(false, 0, 'No data found');
            }
        } catch (err) {
            console.error(err);
            throw err;
        }
        }

    async getProductCountById(req: IdRequest): Promise<CommonResponse> {
        try {
            const res = await this.productCountRepository.findOne({ where: { productCountId: req.Id } });
            if (res) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', res);
            } else {
                return new CommonResponse(false, 0, 'No data found');
            }
        } catch (err) {
            console.error(err);
            throw err;
        }
    }

    async createSkuPrice(req: SkuPriceCreateRequestDto): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager();
        try {
            if (!req?.items?.length) {
                return new CommonResponse(false, 0, 'No SKU price records provided');
            }

            if (req.items.length > 1000) {
                return new CommonResponse(false, 0, 'Maximum 1000 rows allowed per upload');
            }

            const effectiveFrom = moment.utc(req.effectiveFrom).startOf('day').toDate();
            if (!effectiveFrom || isNaN(effectiveFrom.getTime())) {
                return new CommonResponse(false, 0, 'Effective date is required');
            }

            const createdUser = req.createdUser || 'system';
            const skuIdsInRequest = req.items.map((item) => Number(item.skuId));
            const duplicateSkuIds = skuIdsInRequest.filter(
                (id, index) => skuIdsInRequest.indexOf(id) !== index,
            );
            if (duplicateSkuIds.length > 0) {
                const uniqueDupes = [...new Set(duplicateSkuIds)];
                return new CommonResponse(
                    false,
                    0,
                    `Duplicate SKU(s) in request: ${uniqueDupes.join(', ')}`,
                );
            }

            const skuMasterMap = await this.getSkuMasterMap();
            const validationErrors: string[] = [];

            for (let i = 0; i < req.items.length; i++) {
                const item = req.items[i];
                const rowLabel = req.items.length > 1 ? `Row ${i + 1}: ` : '';
                const skuId = Number(item.skuId);
                const price = Number(item.price);

                if (!skuId || isNaN(skuId)) {
                    validationErrors.push(`${rowLabel}SKU is mandatory`);
                    continue;
                }

                if (item.price === undefined || item.price === null || isNaN(price)) {
                    validationErrors.push(`${rowLabel}Price is mandatory and must be numeric`);
                    continue;
                }

                if (price <= 0) {
                    validationErrors.push(`${rowLabel}Price must be greater than zero`);
                    continue;
                }

                const skuInfo = skuMasterMap.get(skuId);
                if (!skuInfo) {
                    validationErrors.push(`${rowLabel}SKU ${skuId} does not exist in master`);
                    continue;
                }

                if (!skuInfo.isActive) {
                    validationErrors.push(`${rowLabel}SKU ${skuInfo.skuLabel} is inactive`);
                    continue;
                }

                const existing = await this.skuPriceRepository.findOne({
                    where: { skuId },
                });

                if (!existing || Number(existing.price) !== price) {
                    const maxEffectiveDate = await this.fetchMaxEffectiveDateForSku(skuId);

                    if (
                        maxEffectiveDate &&
                        moment(effectiveFrom).isSameOrBefore(moment(maxEffectiveDate), 'day')
                    ) {
                        validationErrors.push(
                            `${rowLabel}${skuInfo.skuLabel} was last updated on ${moment(maxEffectiveDate).format('DD-MMM-YYYY')}. Earlier dates are not allowed.`,
                        );
                    }
                }
            }

            if (validationErrors.length > 0) {
                return new CommonResponse(false, 0, validationErrors.join('; '));
            }

            await transactionManager.startTransaction();
            const skuPriceRepo = transactionManager.getRepository(SkuPrice);
            const skuPriceLogsRepo = transactionManager.getRepository(SkuPriceLogs);

            for (const item of req.items) {
                const skuId = Number(item.skuId);
                const price = Number(item.price);
                const existing = await skuPriceRepo.findOne({ where: { skuId } });

                if (existing) {
                    const priceChanged = Number(existing.price) !== price;
                    if (!priceChanged) {
                        continue;
                    }
                    
                        const logEntry = new SkuPriceLogs();
                        logEntry.skuId = existing.skuId;
                        logEntry.effectiveFromDate = existing.effectiveFromDate;
                        logEntry.price = existing.price;
                        logEntry.createdUser = createdUser;
                        logEntry.updatedUser = createdUser;
                        await skuPriceLogsRepo.save(logEntry);

                        existing.price = price;
                        existing.effectiveFromDate = effectiveFrom;
                        existing.updatedUser = createdUser;
                        await skuPriceRepo.save(existing);
                    
                } else {
                    const newEntry = new SkuPrice();
                    newEntry.skuId = skuId;
                    newEntry.price = price;
                    newEntry.effectiveFromDate = effectiveFrom;
                    newEntry.createdUser = createdUser;
                    newEntry.updatedUser = createdUser;
                    await skuPriceRepo.save(newEntry);
                }
            }

            await transactionManager.completeTransaction();
            return new CommonResponse(true, 1, 'SKU price(s) saved successfully');
        } catch (err) {
            await transactionManager.releaseTransaction();
            console.error('createSkuPrice error:', err);
            throw err;
        }
    }

    async getCurrentSkuPrices(req?:any): Promise<CommonResponse> {
    try {
        const manager = getManager();

        let query = `
            SELECT
                sp.sku_id AS skuId,
                sku.short_code AS skuName,
                sp.price AS price,
                sp.effective_from_date AS effectiveFrom
            FROM ${appSettings.rm_procure_db}.sku_price sp
            LEFT JOIN ${appSettings.masters_db}.sku_codes sku
                ON sku.sku_code_id = sp.sku_id
            WHERE 1=1
        `;
    if(req.skuId){
        query+=` AND sp.sku_id = ${req.skuId}`
        }
        query+=` ORDER BY sp.effective_from_date DESC, sp.sku_id ASC`
        const rows = await manager.query(query);

        return new CommonResponse(
            true,
            1,
            'Current SKU prices retrieved successfully',
            rows
        );
    } catch (err) {
        console.error('getCurrentSkuPrices error:', err);
        throw err;
    }
}

    async getSkuPriceByDate(req: SkuPriceByDateRequestDto[]): Promise<CommonResponse> {
    try {

        if (!req?.length) {
            return new CommonResponse(false, 0, 'Request payload is required');
        }

        const manager = getManager();
        const results = [];

        for (const item of req) {

            if (!item?.skuId || !item?.date) {
                continue;
            }

            const requestedDate = moment.utc(item.date).format('YYYY-MM-DD');

            const query = `
                SELECT
                    skuId,
                    skuName,
                    price,
                    effectiveFrom
                FROM
                (
                    SELECT
                        sp.sku_id AS skuId,
                        COALESCE(
                            sku.short_code,
                            sku.variant_code,
                            CAST(sp.sku_id AS CHAR)
                        ) AS skuName,
                        sp.price AS price,
                        sp.effective_from_date AS effectiveFrom
                    FROM ${appSettings.rm_procure_db}.sku_price sp
                    LEFT JOIN ${appSettings.masters_db}.sku_codes sku
                        ON sku.sku_code_id = sp.sku_id
                    WHERE sp.sku_id = ?

                    UNION ALL

                    SELECT
                        spl.sku_id AS skuId,
                        COALESCE(
                            sku.short_code,
                            sku.variant_code,
                            CAST(spl.sku_id AS CHAR)
                        ) AS skuName,
                        spl.price AS price,
                        spl.effective_from_date AS effectiveFrom
                    FROM ${appSettings.rm_procure_db}.sku_price_logs spl
                    LEFT JOIN ${appSettings.masters_db}.sku_codes sku
                        ON sku.sku_code_id = spl.sku_id
                    WHERE spl.sku_id = ?
                ) combined
                WHERE DATE(effectiveFrom) <= ?
                ORDER BY effectiveFrom DESC
                LIMIT 1
            `;

            const row = await manager.query(query, [
                item.skuId,
                item.skuId,
                requestedDate
            ]);

            if (row?.length) {
                results.push({
                    skuId: item.skuId,
                    date: requestedDate,
                    price: row[0].price
                });
            } else {
                results.push({
                    skuId: item.skuId,
                    date: requestedDate,
                    price: null
                });
            }
        }

        if (!results.length) {
            return new CommonResponse(
                false,
                0,
                'No applicable prices found for the given dates'
            );
        }

        return new CommonResponse(
            true,
            1,
            'SKU prices retrieved successfully',
            results
        );

    } catch (err) {
        console.error('getSkuPriceByDate error:', err);
        throw err;
    }
}

    async getSkuPriceHistory(req: SkuPriceHistoryRequestDto): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const params: any[] = [];
            let query = `
                SELECT skuId, skuName, price, effectiveFrom, isCurrent FROM (
                    SELECT
                        sp.sku_id AS skuId,
                        COALESCE(sku.short_code, sku.variant_code, CAST(sp.sku_id AS CHAR)) AS skuName,
                        sp.price AS price,
                        sp.effective_from_date AS effectiveFrom,
                        1 AS isCurrent
                    FROM ${appSettings.rm_procure_db}.sku_price sp
                    LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id = sp.sku_id
                    UNION ALL
                    SELECT
                        spl.sku_id AS skuId,
                        COALESCE(sku.short_code, sku.variant_code, CAST(spl.sku_id AS CHAR)) AS skuName,
                        spl.price AS price,
                        spl.effective_from_date AS effectiveFrom,
                        0 AS isCurrent
                    FROM ${appSettings.rm_procure_db}.sku_price_logs spl
                    LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id = spl.sku_id
                ) history
                WHERE 1=1
            `;

            if (req?.skuId) {
                query += ` AND skuId = ?`;
                params.push(req.skuId);
            }
            if (req?.fromDate) {
                query += ` AND DATE(effectiveFrom) >= ?`;
                params.push(moment.utc(req.fromDate).format('YYYY-MM-DD'));
            }
            if (req?.toDate) {
                query += ` AND DATE(effectiveFrom) <= ?`;
                params.push(moment.utc(req.toDate).format('YYYY-MM-DD'));
            }

            query += ` ORDER BY skuId ASC, effectiveFrom ASC`;

            const rows = await manager.query(query, params);
            const enriched = rows.map((row: any, index: number, arr: any[]) => {
                const nextForSameSku = arr.slice(index + 1).find((r) => r.skuId === row.skuId);
                let effectiveTo: string | null = null;
                if (nextForSameSku) {
                    effectiveTo = moment(nextForSameSku.effectiveFrom).subtract(1, 'day').format('YYYY-MM-DD');
                }
                return {
                    ...row,
                    effectiveTo,
                    isCurrent: row.isCurrent === 1 && !nextForSameSku,
                };
            });

            return new CommonResponse(true, 1, 'SKU price history retrieved successfully', enriched);
        } catch (err) {
            console.error('getSkuPriceHistory error:', err);
            throw err;
        }
    }

    async getSkuMaxEffectiveDate(skuId: number): Promise<CommonResponse> {
        try {
            const maxDate = await this.fetchMaxEffectiveDateForSku(skuId);
            return new CommonResponse(true, 1, 'Max effective date retrieved', {
                skuId,
                maxEffectiveDate: maxDate ? moment(maxDate).format('YYYY-MM-DD') : null,
            });
        } catch (err) {
            console.error('getSkuMaxEffectiveDate error:', err);
            throw err;
        }
    }

    private async fetchMaxEffectiveDateForSku(skuId: number): Promise<Date | null> {
        const manager = getManager();
        const query = `
            SELECT MAX(effectiveFrom) AS maxEffectiveDate FROM (
                SELECT effective_from_date AS effectiveFrom FROM ${appSettings.rm_procure_db}.sku_price WHERE sku_id = ?
                UNION ALL
                SELECT effective_from_date AS effectiveFrom FROM ${appSettings.rm_procure_db}.sku_price_logs WHERE sku_id = ?
            ) combined
        `;
        const result = await manager.query(query, [skuId, skuId]);
        return result?.[0]?.maxEffectiveDate || null;
    }

    private async getSkuMasterMap(): Promise<Map<number, { isActive: boolean; skuLabel: string }>> {
        const manager = getManager();
        const rows = await manager.query(`
            SELECT sku_code_id AS skuId, short_code AS shortCode, variant_code AS variantCode, is_active AS isActive
            FROM ${appSettings.masters_db}.sku_codes
        `);
        const map = new Map<number, { isActive: boolean; skuLabel: string }>();
        for (const row of rows) {
            map.set(Number(row.skuId), {
                isActive: !!row.isActive,
                skuLabel: row.shortCode || row.variantCode || String(row.skuId),
            });
        }
        return map;
    }

    async resolveSkuIdFromValue(
        skuValue: string | number,
        skuMasterRows?: any[],
    ): Promise<number | null> {
        const rows = skuMasterRows || (await getManager().query(`
            SELECT sku_code_id AS skuId, short_code AS shortCode, variant_code AS variantCode, is_active AS isActive
            FROM ${appSettings.masters_db}.sku_codes
        `));

        const normalized = String(skuValue).trim();
        if (!normalized) {
            return null;
        }

        if (!isNaN(Number(normalized))) {
            const byId = rows.find((r) => Number(r.skuId) === Number(normalized));
            return byId ? Number(byId.skuId) : null;
        }

        const match = rows.find(
            (r) =>
                String(r.shortCode).toLowerCase() === normalized.toLowerCase() ||
                String(r.variantCode).toLowerCase() === normalized.toLowerCase(),
        );
        return match ? Number(match.skuId) : null;
    }
}
